"use client";
import InpSafeForm from "@/components/atoms/FormComponents/InpSafeForm";
import { UnivoLink } from "@/components/common";
import { onInpSafeButtonClick } from "@/helpers/inpSafeForm";

import React from "react";
import { Controller } from "react-hook-form";
import cn, { clsx } from "clsx";
import styles from "./NewBannerForm.module.scss";
import StatsContainer from "../StatsContainer/StatsContainer";
import { getDefaultCountryCode, getCountryList } from "./utils";
import StatsContainerFaq from "../StatsContainerFaq/StatsContainerFaq";
import CountryDropdownGlobalWhite from "@/components/atoms/FormComponents/CustomDropDownWhite/CustomDropdownGlobalWhite";
import Checkbox from "@/components/atoms/FormComponents/Checkbox";
import DelayCommonModal from "../modal/ConnectModal/ConnectModalWrapper";
import Select from "@/components/atoms/FormComponents/Select";
import { PROGRAM_DROPDOWN } from "@/components/molecules/ProgramMenu/constants";
import AffiliateExistingLeadPopUp from "./AffiliateExistingLeadPopUp";
import { SELECT_DEGREE, SELECT_PROGRAM, SELECT_PMI_PATHWAY, PMI_PATHWAY_OPTIONS, PMI_PATHWAY_VALUES } from "./model/programDetailsOpenRfi.types";
import { useProgramDetailsOpenRfiController } from "./controller/useProgramDetailsOpenRfiController";
import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";

const degreeOptions = ["UG", "PG"];

interface BannerImageTempleteType {
  ShortDescLabel1?: string;
  ShortDescLabel2?: string;
  ShortDescLabel3?: string;
  ShortDescSubLabel1?: string;
  ShortDescSubLabel2?: string;
  ShortDescSubLabel3?: string;
  SeatsFilled?: string;
}

const exlcudePrograms = [
  "BSc. (Hons.) in Information Technology",
  "MSc. in Information Technology",
  "MSc. Environmental Science",
];

const programsOptions = PROGRAM_DROPDOWN.filter(
  (e) => !exlcudePrograms.includes(e.title)
)
  .filter(
    (x: any) =>
      x.programType &&
      degreeOptions.indexOf(String(x.programType).toUpperCase()) > -1
  )
  .map((x: any) => x.title);

function ProgramDetailsOpenRfiInner(props: {
  ProgramId?: any;
  associatedPrograms: Array<ProgramDetails>;
  isMobile?: boolean;
  setLeadFailed?: (x: boolean) => void;
  setApplicationRedirectLoaderDisabled: (value: boolean) => void;
  isFaq?: boolean
  BannerImageTemplete?: BannerImageTempleteType
  isLandingPage?: boolean;
  isLambdaAPI?: boolean;
  isAffiliatePage?: boolean;
  seatFilledCount?: number
  isJobRole?: boolean
  seatFilledDisplay?: boolean;
  isStatsDisplay?: boolean;
  ctaButtonLabel?: string;
  isOneYearMba?: boolean;
}) {

  const { isMobile, associatedPrograms, setApplicationRedirectLoaderDisabled, BannerImageTemplete, isFaq, isLandingPage = false, isLambdaAPI = false, isAffiliatePage = false, isJobRole } = props;

  const {
    control,
    errors,
    isSubmitting,
    isOTPLoading,
    programsList,
    message,
    showExistingLead,
    isPmi,
    closeExistingLead,
    handleFieldChange,
    handleFieldBlur,
    updateCountryCode,
    handleFormSubmit,
    handlePreDegree,
  } = useProgramDetailsOpenRfiController({
    ProgramId: props.ProgramId,
    associatedPrograms,
    isLandingPage,
    isAffiliatePage,
    isLambdaAPI,
    isJobRole,
    programsOptions,
    defaultCountryCode: getDefaultCountryCode({ isAffiliatePage }),
    countryList: getCountryList({ isAffiliatePage }),
    setApplicationRedirectLoaderDisabled,
  });

  const isLoading = isSubmitting;

  const SeatFilledCount = isJobRole ? Number(props?.seatFilledCount) : Number(BannerImageTemplete?.SeatsFilled);

  const handleSingleFieldChange = handleFieldChange;
  const makeFormSubmission = handleFormSubmit;

  return (
    <div className="relative">
      {showExistingLead && isAffiliatePage && (
        <AffiliateExistingLeadPopUp onClose={closeExistingLead} />
      )}
      <InpSafeForm onSubmit={makeFormSubmission} onFocus={handlePreDegree}>
        <div className={cn(styles.form_container, isJobRole && "!gap-4 lg:!gap-8")}>
          <div className={styles.field_container}>
            {
              isPmi ? (
                <div className="w-full flex mt-2 gap-2">
                  <div className="w-1/2">
                    <Controller
                      name="fullName"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <input
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            className={cn(styles.text_field, "w-full mt-3 flex-1")}
                            value={field.value ?? ""}
                            onChange={(event) => handleSingleFieldChange("fullName", event.target.value)}
                            onBlur={() => {
                              field.onBlur();
                              handleFieldBlur("fullName", "", fieldState.error?.message ?? errors.fullName);
                            }}
                            id="fullName"
                          />
                          <p className={cn(styles.error)}>{fieldState.error?.message ?? errors.fullName}</p>
                        </>
                      )}
                    />
                  </div>
                  <div className="w-1/2">
                    <Controller
                      name="emailId"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <input
                            type="text"
                            name="email"
                            id="email"
                            placeholder="Email Address"
                            value={field.value ?? ""}
                            className={cn(styles.text_field, "w-full mt-3")}
                            onChange={(event) => handleSingleFieldChange("emailId", event.target.value)}
                            onBlur={field.onBlur}
                          />
                          <p className={cn(styles.error)}>{fieldState.error?.message ?? errors.emailId}</p>
                        </>
                      )}
                    />
                  </div>
                </div>
              ) : (
                <div className="w-full mt-2">
                  <Controller
                    name="fullName"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <input
                          type="text"
                          name="name"
                          placeholder="Full Name"
                          className={cn(styles.text_field, "w-full")}
                          value={field.value ?? ""}
                          onChange={(event) => handleSingleFieldChange("fullName", event.target.value)}
                          onBlur={() => {
                            field.onBlur();
                            handleFieldBlur("fullName", "", fieldState.error?.message ?? errors.fullName);
                          }}
                          id="fullName"
                        />
                        <p className={cn(styles.error)}>{fieldState.error?.message ?? errors.fullName}</p>
                      </>
                    )}
                  />
                </div>
              )
            }

            <div className="lg:mt-3">
              <div className={cn(styles.select_container, isJobRole && "!gap-2")}>
                <Controller
                  name="countryCode"
                  control={control}
                  render={({ field }) => (
                    <CountryDropdownGlobalWhite
                      onChangeFunc={(value: string) => handleSingleFieldChange("countryCode", value)}
                      countries={getCountryList({ isAffiliatePage })}
                      countryCode={field.value}
                      updateCountryCode={updateCountryCode}
                      additionalStyle={cn(styles.text_field, "lining-nums h-full")}
                      isDark={false}
                      disabled={isLoading || isOTPLoading}
                    />
                  )}
                />
                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field, fieldState }) => (
                    <input
                      type="text"
                      name="mobile"
                      placeholder="Mobile No."
                      className={cn(styles.text_field, "w-full lining-nums")}
                      value={field.value ?? ""}
                      id="phoneNumber"
                      onChange={(event) => handleSingleFieldChange("phoneNumber", event.target.value)}
                      onBlur={() => {
                        field.onBlur();
                        handleFieldBlur("phoneNumber", "", fieldState.error?.message ?? errors.phoneNumber);
                      }}
                    />
                  )}
                />
              </div>
              <p className={cn(styles.error)}>{errors.countryCode || errors.phoneNumber}</p>
            </div>

            {!isPmi && <div>
              <Controller
                name="emailId"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      placeholder="Email Address"
                      value={field.value ?? ""}
                      className={cn(styles.text_field, "w-full mt-3")}
                      onChange={(event) => handleSingleFieldChange("emailId", event.target.value)}
                      onBlur={field.onBlur}
                    />
                    <p className={cn(styles.error)}>{fieldState.error?.message ?? errors.emailId}</p>
                  </>
                )}
              />
            </div>}
            {isLandingPage && (
              <>
                <div className={styles.inputWrapper}>
                  <div className={cn(styles.commonMargins, "w-full")}>
                    <Controller
                      name="degree"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <Select
                            value={field.value}
                            onChangeFunc={(value: string) => {
                              handleSingleFieldChange("degree", value);
                            }}
                            options={[SELECT_DEGREE, ...degreeOptions]}
                            disabled={isLoading || isOTPLoading}
                            id="degree_lookup"
                            isBorderReq={false}
                          />
                          <p className={cn(styles.error)}>{fieldState.error?.message ?? errors.degree}</p>
                        </>
                      )}
                    />
                  </div>
                </div>
                <div className={styles.inputWrapper}>
                  <div className={cn(styles.commonMargins, "w-full")}>
                    <Controller
                      name="program"
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <Select
                            value={field.value}
                            onChangeFunc={(value: string) => {
                              handleSingleFieldChange("program", value);
                            }}
                            options={[SELECT_PROGRAM, ...programsList]}
                            disabled={isLoading || isOTPLoading}
                            id="program_lookup"
                            isBorderReq={false}
                          />
                          <p className={cn(styles.error)}>{fieldState.error?.message ?? errors.program}</p>
                        </>
                      )}
                    />
                  </div>
                </div>
              </>)}
            {isPmi && (
              <div className={styles.inputWrapper}>
                <div className={cn(styles.commonMargins, "w-full")}>
                  <Controller
                    name="pmiPathway"
                    control={control}
                    render={({ field, fieldState }) => (
                      <>
                        <Select
                          value={field.value}
                          onChangeFunc={(value: string) => {
                            handleSingleFieldChange("pmiPathway", value);
                          }}
                          options={[SELECT_PMI_PATHWAY, ...PMI_PATHWAY_OPTIONS]}
                          values={[SELECT_PMI_PATHWAY, ...PMI_PATHWAY_VALUES]}
                          disabled={isLoading || isOTPLoading}
                          id="pmi_pathway_lookup"
                          isBorderReq={false}
                          className={styles.pmiPathwaySelect}
                        />
                        <p className={cn(styles.error)}>{fieldState.error?.message ?? errors.pmiPathway}</p>
                      </>
                    )}
                  />
                </div>
              </div>
            )}
            <div className={cn(styles.commonMargins, "mt-3")}>
              <div className="flex gap-3 items-start">
                <div className="shrink-0">
                  <Controller
                    name="isTermsAccepted"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Checkbox
                        name="consent"
                        value={field.value}
                        onChangeFunc={(value: boolean) => {
                          handleSingleFieldChange("isTermsAccepted", value);
                          DelayCommonModal(
                            handleFieldBlur,
                            "isTermsAccepted",
                            "",
                            fieldState.error?.message ?? errors.isTermsAccepted,
                          );
                        }}
                        disabled={isLoading || isOTPLoading}
                        style={{ padding: "0.4rem" }}
                      />
                    )}
                  />
                </div>
                <p className={cn(styles.text)}>
                  By entering these details I agree that Amity University Online and its associates can contact me with updates & notifications via Email, SMS, WhatsApp, and Voice call as per its <UnivoLink href="https://amityonline.com/privacy-policy" external style={{ textDecoration: "underline", textDecorationColor: "inherit", cursor: "pointer" }}>Privacy Policy</UnivoLink>. This consent will override any registration for DNC / NDNC.
                </p>
              </div>
              <p className={cn(styles.termserror)}>{errors.isTermsAccepted}</p>
            </div>

            <div className={cn(styles.btn_container)}>
              <button
                type="button"
                className={clsx(styles.btn, {
                  [styles.btnDisabled]: isLoading || isOTPLoading,
                })}
                disabled={isLoading || isOTPLoading}
                // Parent template wraps the form in onClick → lead_initiate.
                // Block bubble so invalid Submit clicks do not fire that
                // initiate event / GTM cascade. Field clicks still do.
                onClick={onInpSafeButtonClick}
                aria-busy={isLoading || isOTPLoading}
              >
                <span className={styles.btnContent}>
                  {(isLoading || isOTPLoading) && (
                    <span className={styles.btnSpinner} aria-hidden="true" />
                  )}
                  {(isLoading || isOTPLoading) ? "Submitting..." : (props.ctaButtonLabel ?? "Get Free Counselling")}
                </span>
              </button>
            </div>

            {
              !!SeatFilledCount && props.seatFilledDisplay && !props.isOneYearMba && (
                <div className={cn(styles.filled_seat_container, `${props?.isFaq ? "mt-[1.2rem]" : "mt-3"}`)}>
                  <div
                    className={cn(styles.filled_seats)}
                    style={{ "--progress": SeatFilledCount / 100 } as React.CSSProperties}
                  >
                    <div className={styles.filled}></div>
                  </div>
                  <div className={cn(clsx(styles.text), "lining-nums")}>{SeatFilledCount}% Seats filled</div>
                </div>
              )
            }
          </div>
          {props.isStatsDisplay && !isJobRole && !props.isOneYearMba && (isFaq ? <StatsContainerFaq BannerImageTemplete={BannerImageTemplete} isStatsDisplay={true} /> :
            <StatsContainer BannerImageTemplete={BannerImageTemplete} isStatsDisplay={isMobile} />)
          }
          {message && message}
        </div>
      </InpSafeForm>
    </div>
  );
}

export default function ProgramDetailsOpenRfi(props: {
  ProgramId?: any;
  associatedPrograms: Array<ProgramDetails>;
  isMobile?: boolean;
  setLeadFailed?: (x: boolean) => void;
  setApplicationRedirectLoaderDisabled: (value: boolean) => void;
  isFaq?: boolean
  BannerImageTemplete?: BannerImageTempleteType
  isLandingPage?: boolean;
  isLambdaAPI?: boolean;
  isAffiliatePage?: boolean;
  seatFilledCount?: number
  isJobRole?: boolean
  seatFilledDisplay?: boolean;
  isStatsDisplay?: boolean;
  ctaButtonLabel?: string;
  isOneYearMba?: boolean;
  slug?: string;
}) {
  return (
    <SectionErrorBoundary sectionName="ProgramDetailsOpenRfi">
      <ProgramDetailsOpenRfiInner {...props} />
    </SectionErrorBoundary>
  );
}
